import Vue from 'vue'

Vue.filter('dateFormatDefault', (string) => {
  const dateObj = new Date(string)
  return new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(dateObj)
})
